(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BA_supa-amino-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('aminoCalc');
  if (!root) return;

  var SUPA = { leucine: 3.4, protein: 21, cal: 90 };

  // leucine/cal per 100g (USDA FoodData Central, approx) + a household unit for readability.
  var FOODS = [
    { name: 'Greek Yogurt',   emoji: '🥛', leu100: 1.0, cal100: 59,  unitG: 245, unit: 'cup',  unitP: 'cups' },
    { name: 'Cottage Cheese', emoji: '🧀', leu100: 1.1, cal100: 84,  unitG: 226, unit: 'cup',  unitP: 'cups' },
    { name: 'Whole Eggs',     emoji: '🥚', leu100: 1.1, cal100: 143, unitG: 50,  unit: 'egg',  unitP: 'eggs' },
    { name: 'Chicken Breast', emoji: '🍗', leu100: 2.5, cal100: 165, unitG: 28,  unit: 'oz',   unitP: 'oz' },
    { name: 'Whole Milk',     emoji: '🥛', leu100: 0.3, cal100: 61,  unitG: 244, unit: 'cup',  unitP: 'cups' },
    { name: 'Firm Tofu',      emoji: '🧈', leu100: 1.2, cal100: 144, unitG: 252, unit: 'block',unitP: 'blocks' },
    { name: 'Lean Beef',      emoji: '🥩', leu100: 2.3, cal100: 217, unitG: 28,  unit: 'oz',   unitP: 'oz' },
    { name: 'Pork Loin',      emoji: '🥓', leu100: 2.2, cal100: 209, unitG: 28,  unit: 'oz',   unitP: 'oz' },
    { name: 'Salmon',         emoji: '🐟', leu100: 2.0, cal100: 206, unitG: 28,  unit: 'oz',   unitP: 'oz' }
  ];

  var chipsWrap = root.querySelector('.calc-chips');
  var el = {
    foodName: root.querySelector('#calcFoodName'), emoji: root.querySelector('#calcEmoji'),
    qty: root.querySelector('#calcQty'), grams: root.querySelector('#calcGrams'),
    cals: root.querySelector('#calcCals'), barSupa: root.querySelector('#barSupa'),
    barFood: root.querySelector('#barFood'), barFoodLbl: root.querySelector('#barFoodLbl'),
    note: root.querySelector('#calcDensityNote')
  };
  function round(n, d) { var f = Math.pow(10, d || 0); return Math.round(n * f) / f; }

  function render(food) {
    var grams = SUPA.leucine / (food.leu100 / 100);   // grams of food with the same leucine
    var units = grams / food.unitG;
    var cals = grams * food.cal100 / 100;
    var qty = (food.unit === 'egg' || food.unit === 'oz')
      ? '≈ ' + Math.round(units) + ' ' + (Math.round(units) === 1 ? food.unit : food.unitP)
      : '≈ ' + round(units, 1) + ' ' + (round(units, 1) === 1 ? food.unit : food.unitP);

    el.foodName.textContent = food.name;
    el.emoji.textContent = food.emoji;
    el.qty.textContent = qty;
    el.grams.textContent = '(' + Math.round(grams) + 'g)';
    el.cals.textContent = Math.round(cals);
    el.barFoodLbl.textContent = food.name;

    var supaDensity = SUPA.leucine / SUPA.cal * 100;
    var foodDensity = (food.leu100 / food.cal100) * 100;
    var max = Math.max(supaDensity, foodDensity);
    el.barSupa.style.width = (supaDensity / max * 100) + '%';
    el.barFood.style.width = (foodDensity / max * 100) + '%';
    el.note.textContent = 'A SUPA shot gives you that leucine at ' + round(supaDensity / foodDensity, 1) + '× the density — the lean way to top up.';
  }

  FOODS.forEach(function (food, i) {
    var b = document.createElement('button');
    b.className = 'calc-chip'; b.type = 'button'; b.setAttribute('role', 'tab');
    b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
    b.innerHTML = food.emoji + ' ' + food.name;
    b.addEventListener('click', function () {
      chipsWrap.querySelectorAll('.calc-chip').forEach(function (c) { c.setAttribute('aria-selected', 'false'); });
      b.setAttribute('aria-selected', 'true'); render(food);
    });
    chipsWrap.appendChild(b);
  });

  var started = false;
  var obs = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting && !started) { started = true; render(FOODS[0]); } });
  }, { threshold: 0.25 });
  obs.observe(root);
  render(FOODS[0]);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BA_supa-amino-profile"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Animate the hero leucine bars when they scroll into view.
  var hero = document.getElementById('aminoHero');
  if (hero) {
    var bars = hero.querySelectorAll('.hb');
    bars.forEach(function (b) { b.style.width = '0%'; });
    var done = false;
    var obs = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting && !done) { done = true; bars.forEach(function (b) { b.style.width = b.dataset.w; }); } });
    }, { threshold: 0.35 });
    obs.observe(hero);
  }
  // Full-table bars: set width immediately (behind the expand toggle).
  document.querySelectorAll('#aminoChart .bar').forEach(function (b) { b.style.width = b.dataset.w; });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BA_supa-faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.faq-q').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.parentElement;
    const ans = item.querySelector('.faq-a');
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(i => { i.classList.remove('open'); i.querySelector('.faq-a').style.maxHeight = null; });
    if (!isOpen) { item.classList.add('open'); ans.style.maxHeight = ans.scrollHeight + 'px'; }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BA_supa-header"] && !Shopify.designMode) return;
  try {
    
const header = document.getElementById('siteHeader');
if (header) window.addEventListener('scroll', () => header.classList.toggle('scrolled', window.scrollY > 8));
const burger = document.getElementById('burger');
const mobileMenu = document.getElementById('mobileMenu');
if (burger && mobileMenu) {
  burger.addEventListener('click', () => { const open = mobileMenu.classList.toggle('open'); burger.setAttribute('aria-expanded', open); });
  mobileMenu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => { mobileMenu.classList.remove('open'); burger.setAttribute('aria-expanded', 'false'); }));
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BA_supa-leucine-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sec = document.querySelector('.sec--leucine-story');
  if (!sec) return;
  var bars = sec.querySelectorAll('.hb');
  bars.forEach(function (b) { b.style.width = '0%'; });
  var done = false;
  var obs = new IntersectionObserver(function (es, o) {
    es.forEach(function (e) {
      if (e.isIntersecting && !done) {
        done = true;
        sec.classList.add('in-view');
        bars.forEach(function (b) { b.style.width = b.dataset.w; });
        o.disconnect();
      }
    });
  }, { threshold: 0.25 });
  obs.observe(sec);
  sec.querySelectorAll('#lsChart .bar').forEach(function (b) { b.style.width = b.dataset.w; });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BA_supa-leucine-wave"] && !Shopify.designMode) return;
  try {
    
const lw = document.querySelector('.sec--leucine');
if (lw) {
  const obs = new IntersectionObserver((entries, o) => { entries.forEach(e => { if (e.isIntersecting) { lw.classList.add('in-view'); o.disconnect(); } }); }, { threshold: 0.3 });
  obs.observe(lw);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BA_supa-offer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';

  function sectionsParam() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.dataset.sectionId;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids.join(',');
  }

  function refreshAndOpenDrawer(cart, variantId, sectionsHtml) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart || undefined,
          sourceId: 'ba-supa-offer',
          data: { source: 'ba-supa-offer', variantId: variantId, sections: sectionsHtml || {} },
        },
      })
    );
    var open = function () {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') drawer.open();
    };
    if (window.customElements && customElements.get('cart-drawer-component')) {
      open();
    } else if (window.customElements) {
      customElements.whenDefined('cart-drawer-component').then(open);
    } else {
      open();
    }
  }

  function addToCart(btn, variantId, sellingPlan) {
    if (!variantId) {
      console.error('[BA Supa Offer] Missing variant id for add to cart.');
      return;
    }
    btn.disabled = true;
    var item = { id: Number(variantId), quantity: 1 };
    if (sellingPlan) item.selling_plan = Number(sellingPlan);
    // Attribution: hidden line props ("_" prefix) ride through to the order line item.
    item.properties = { _atc_source: 'home-offer', _atc_page: location.pathname };

    var sections = sectionsParam();
    var body = { items: [item] };
    if (sections) body.sections = sections;

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          console.error('[BA Supa Offer] cart/add.js error:', result.data.description || result.data.message || result.data);
          btn.disabled = false;
          return;
        }
        var sectionsHtml = result.data.sections || {};
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .catch(function () { return undefined; })
          .then(function (cart) {
            refreshAndOpenDrawer(cart, variantId, sectionsHtml);
            btn.disabled = false;
          });
      })
      .catch(function (err) {
        console.error('[BA Supa Offer] cart/add.js request failed:', err);
        btn.disabled = false;
      });
  }

  document.querySelectorAll('.sec--offer [data-offer-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      addToCart(btn, btn.dataset.variant, btn.dataset.plan);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BA_supa-pdp-buybox"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.pdpbuyInitialized === 'true') return;
    var qtyInput = root.querySelector('#pdpbuy-qty');
    var atc = root.querySelector('.pdpbuy__atc');
    if (!qtyInput || !atc) return;
    root.dataset.pdpbuyInitialized = 'true';

    root.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(qtyInput.value, 10) || 1;
        n += parseInt(b.getAttribute('data-qty'), 10);
        if (n < 1) n = 1;
        qtyInput.value = n;
      });
    });

    root.querySelectorAll('.pdpbuy__faq-button').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('.pdpbuy__faq-item');
        var wasOpen = button.getAttribute('aria-expanded') === 'true';
        root.querySelectorAll('.pdpbuy__faq-item').forEach(function (otherItem) {
          var otherButton = otherItem.querySelector('.pdpbuy__faq-button');
          var otherAnswer = otherItem.querySelector('.pdpbuy__faq-answer');
          otherItem.classList.remove('is-open');
          otherButton.setAttribute('aria-expanded', 'false');
          otherAnswer.hidden = true;
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
          item.querySelector('.pdpbuy__faq-answer').hidden = false;
        }
      });
    });

    var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
    function sectionsParam() {
      var ids = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
        var id = el.dataset.sectionId; if (id && ids.indexOf(id) === -1) ids.push(id);
      });
      return ids.join(',');
    }
    function openDrawer(cart, sectionsHtml) {
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'ba-supa-pdpbuy', data: { source: 'ba-supa-pdpbuy', sections: sectionsHtml || {} } } }));
      var open = function () { var d = document.querySelector('cart-drawer-component'); if (d && typeof d.open === 'function') d.open(); };
      if (window.customElements && customElements.get('cart-drawer-component')) open();
      else if (window.customElements) customElements.whenDefined('cart-drawer-component').then(open);
    }

    atc.addEventListener('click', function () {
      var checked = root.querySelector('input[name="purchase"]:checked');
      var variantId = atc.getAttribute('data-variant');
      var plan = checked && checked.value === 'sub' ? checked.getAttribute('data-plan') : null;
      var item = { id: Number(variantId), quantity: parseInt(qtyInput.value, 10) || 1 };
      if (plan) item.selling_plan = Number(plan);
      item.properties = { _atc_source: 'pdp-buybox', _atc_page: location.pathname };
      atc.disabled = true;
      var sections = sectionsParam();
      var body = { items: [item] };
      if (sections) body.sections = sections;
      fetch(addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok || res.data.status) { console.error('[BA Supa PDP] add error', res.data); atc.disabled = false; return; }
          var sectionsHtml = res.data.sections || {};
          fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return undefined; })
            .then(function (cart) { openDrawer(cart, sectionsHtml); atc.disabled = false; });
        })
        .catch(function (e) { console.error('[BA Supa PDP] request failed', e); atc.disabled = false; });
    });
  }

  function initAll(scope) {
    if (scope.matches && scope.matches('.sec--pdpbuy')) init(scope);
    scope.querySelectorAll('.sec--pdpbuy').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BA_supa-recipe-index"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.currentScript ? document.currentScript.closest('section') : document.querySelector('.sec--rcpidx');
  if (!root) return;
  var pills = root.querySelectorAll('.rcpidx__pill');
  var cards = root.querySelectorAll('.rcpidx__card');
  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      var f = pill.getAttribute('data-filter');
      pills.forEach(function (p) { p.classList.toggle('is-active', p === pill); });
      cards.forEach(function (c) {
        var show = f === 'all' || c.getAttribute('data-cat') === f;
        c.classList.toggle('is-hidden', !show);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BA_supa-reviews"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ugc-card.ugc-video').forEach(card => {
  const v = card.querySelector('video');
  if (!v) return;
  card.addEventListener('click', () => {
    if (v.paused) {
      document.querySelectorAll('.ugc-card.ugc-video video').forEach(o => { if (o !== v) { o.pause(); o.muted = true; o.closest('.ugc-card').classList.remove('playing'); } });
      v.muted = false; v.play(); card.classList.add('playing');
    } else { v.pause(); card.classList.remove('playing'); }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BA_supa-sticky-atc"] && !Shopify.designMode) return;
  try {
    
const stickyAtc = document.getElementById('stickyAtc');
const offerSec = document.getElementById('offer');
if (stickyAtc) window.addEventListener('scroll', () => {
  const past = window.scrollY > 700;
  let inOffer = false;
  if (offerSec) { const t = offerSec.getBoundingClientRect().top; inOffer = t < window.innerHeight && t > -offerSec.offsetHeight; }
  stickyAtc.classList.toggle('show', past && !inOffer);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
